import axios from 'axios'
import { apiHost } from '../config/env.conf'

export default {

    /**
     * 获取云标签
     * @param { int } did     产品ID
     * @param { int } channel 来源，1 美团 2 点评
     */
    getTags (did, channel) {
        return axios.get(`/rimet/fe/mtp/comment/api/travel/deal/tag`, {
            params: {
                did: did,
                channel: channel
            }
        })
    },

    /**
     * 根据标签获取评价
     * @param { int }    did     产品ID
     * @param { int }    channel 来源，1 美团 2 点评
     * @param { string } tag     标签名
     * @param { int }    page    第几页
     * @param { int }    count   一页展示几条
     */
    getCommentsForTag (did, channel, tag, page = 1, count = 20) {
        return axios.get(`/rimet/fe/mtp/comment/api/travel/deal/tag/comments`, {
            params: {
                did: did,
                channel: channel,
                tag: tag,
                page: page,
                count: count
            }
        })
    },

    /**
     * 根据回复情况获取评价
     * @param { int } did       产品ID
     * @param { int } channel   来源，1 美团 2 点评
     * @param { int } replyType 回复类型，1 全部 2 未回复
     * @param { int } page      第几页
     * @param { int } count     一页展示几条
     */
    getCommentsForReply (did, channel, replyType, page = 1, count = 20) {
        return axios.get(`/rimet/fe/mtp/comment/api/travel/deal/reply/comments`, {
            params: {
                did: did,
                channel: channel,
                replyType: replyType,
                page: page,
                count: count
            }
        })
    },

    /**
     * 根据日期、星级获取评价
     * @param { int }    did       产品ID
     * @param { int }    channel   来源，1 美团 2 点评
     * @param { string } startDate 开始时间
     * @param { string } endDate   结束时间
     * @param { list }   starLevel 星级
     * @param { int }    page      第几页
     * @param { int }    count     一页展示几条
     */
    getCommentsForOthers (did, channel, startDate, endDate, starLevels, page = 1, count = 20) {
        return axios.get(`/rimet/fe/mtp/comment/api/travel/deal/v2/comments`, {
            params: {
                did: did,
                channel: channel,
                startDate: startDate,
                endDate: endDate,
                starLevels: starLevels,
                page: page,
                count: count
            }
        })
    },

    /**
     * 根据有无内容获取评价
     * @param { int } did         产品ID
     * @param { int } contentType 有无内容，0 全部 1 有内容 2 无内容
     * @param { int } page        第几页
     * @param { int } count       一页展示几条
     */
    getCommentsForContent (did, contentType, page = 1, count = 20) {
        return axios.get(`/rimet/fe/mtp/comment/api/travel/deal/content/comments`, {
            params: {
                did: did,
                contentType: contentType,
                page: page,
                count: count
            }
        })
    },

    /**
     * 获取产品列表及筛选
     * @param { int }    businessType 业务线
     * @param { string } searchStr    搜索内容
     * @param { int }    page         第几页
     * @param { int }    count        一页展示几条
     */
    getProductList (businessType, searchStr, page = 1, count = 10) {
        return axios.get(`/rimet/fe/mtp/comment/api/travel/deal/list`, {
            params: {
                businessType: businessType,
                searchStr: searchStr || null,
                page: page,
                count: count
            }
        })
    },

    /**
     * 获取默认产品
     * @param { int } businessType 业务线
     */
    getDefaultProduct (businessType) {
        return axios.get(`/rimet/fe/mtp/comment/api/travel/deal/default`, {
            params: {
                businessType: businessType
            }
        })
    },

    /**
     * 提交商家回复
     * @param { int }    did       项目ID
     * @param { string } reply     回复内容
     * @param { int }    commentId 评价ID
     * @param { int }    poiId     该评价所属的景点ID
     */
    postCommentReply (did, reply, commentId, poiId) {
        const params = {
            did: did,
            reply: reply,
            commentId: commentId,
            poiId: poiId
        }
        return axios.post(`/rimet/fe/mtp/comment/api/travel/comments/${commentId}/reply`, params)
    },

    /**
     * 评价下载
     * @param { int } did     产品ID
     * @param { int } channel 来源，1 美团 2 点评
     */
    uploadComment (did, channel) {
        window.open(`${apiHost}/rimet/fe/mtp/comment/api/travel/download?dealId=${did}&channel=${channel}`)
    }

}



// WEBPACK FOOTER //
// ./src/api/comment.js